import React from 'react'
import { Tooltip, Icon } from 'antd'

import './styles.scss'

export default ({ info }) => (
  <Tooltip title={info}>
    <Icon type="info-circle-o" />
  </Tooltip>
)
